<template>
  <div class="header">
    <a-layout-header :class="{black:!showNormal}" >
      <!-- <div class="logo" /> -->
     <img v-if="showNormal" class="logo image-class" src="../assets/u13.png" />
    <img v-if="!showNormal" class="logo image-class" src="../assets/image/logo1.png" />
        <!-- <SearchOutlined  v-if="!showNormal" style="fontSize:25px;color:#fff"/> -->
      <div class="right" v-if="showNormal" @mouseover="mouseOver" @mouseleave="mouseleave">
        <img src="../assets/avater.png" alt="">
        <span>{{userName}}</span>
        <ul class="showItem" v-show="showItem">
            <li class="li" @click="turnPath">修改密码</li>
            <li class="li" @click="turnPath1">退出</li>
        </ul>
      </div>
    </a-layout-header>
    <!-- <div class="title">
      <img class="image-class" src="../assets/u13.png" />
      <div class="right" @mouseover="mouseOver" @mouseleave="mouseleave">
        <img src="../assets/avater.png" alt="">
        <span>{{userName}}</span>
        <ul class="showItem" v-show="showItem">
            <li class="li" @click="turnPath">修改密码</li>
            <li class="li" @click="turnPath1">退出</li>
        </ul>
      </div>
    </div> -->
  </div>
</template>

<script>
import { SearchOutlined } from "@ant-design/icons-vue";
export default {
    props:["showNormal"],
    data(){
        return{
            showItem:false,
            userName:localStorage.getItem('userName')?localStorage.getItem('userName'):''
        }
    },
    components:{
        SearchOutlined
    },
    mounted(){
    },
    methods:{
        mouseOver(){
            this.showItem = true
        },
        mouseleave(){
            this.showItem = false
        },
        turnPath(){
            this.$router.push('warningChangePwd')
        },
        turnPath1(){
            localStorage.clear()
            this.$router.push('warninglogin')
        }
    }
}
</script>

<style lang="less">
    .header{
        width: 100%;
        .black{
            background-color: #000;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #D9D9D9;
            padding-left: 152px;
            .image-class{
                width: 175px;
                margin: 0;
            }
        }
        .image-class {
            width: 137px;
            margin-bottom: 3px;
            margin-left: 20px;
        }
        .right{
            position: relative;
            cursor: pointer;
            float: right;
            div {
            display: flex;
            flex-direction: row;
            align-items: center;
            }
            span {
                color: #aaa;
                margin-left: 20px;
                margin-right: 40px;
            }
            img{
                width: 24px;
            }
             .showItem{
                position: absolute;
                background-color: #fff;
                width: 120px;
                top: 60px;
                left: 0;
                box-shadow: 3px 3px 5px #888888;
                z-index: 999;
                padding: 10px 0px;
                list-style: none;
                .li{
                    font-size: 15px;
                    padding: 10px 0;
                    text-align: center;
                    line-height: initial;
                    &:hover{
                        background-color: #333;
                        color: #fff;
                    }
                    // border-bottom: 1px solid #333;
                }
            }
        }
       
         .title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            background: black;
            height: 75px;
            width: 100vw;
           
            & > div {
            display: flex;
            flex-direction: row;
            align-items: center;
            & > span {
                color: #aaa;
                margin-left: 20px;
                margin-right: 40px;
            }
            }
        }
    }
</style>